import { assert_string_object_id_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__grid2d_get_by_entity_type_and_id extends DTO__base {
  /*
   *
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GRID2D_GET_BY_ENTITY_TYPE_AND_ID;

  /*
   *
   */
  workspace_id!: string;
  entity_type!: string;
  entity_id!: string;

  /*
   *
   */

  assert_standard_fields(): void {
    assert_string_object_id_not_empty(this.workspace_id);
    assert_type_enum(this.entity_type, ENUM__workspace_entity);
    assert_string_object_id_not_empty(this.entity_id);
  }
}
